import React from 'react';
import ProfileSection from './ProfileSection';

/**
 * Titled sections, each a list with a numbered (per section) or dot marker beside every item.
 * @param {{
 *   sections: { id: string, title: string, items: any[], emptyText: string }[],
 *   renderItem: (item: any, index: number) => React.ReactNode,
 *   getItemKey: (item: any, index: number) => string,
 *   marker?: 'number' | 'dot',
 * }} props `emptyText` shows in a section with no items; `marker` defaults to 'number'
 */
const NumberedSections = ({ sections, renderItem, getItemKey, marker = 'number' }) => {
    const List = marker === 'dot' ? 'ul' : 'ol';

    return (
        <>
            {sections.map((section) => (
                <ProfileSection key={section.id} title={section.title}>
                    {section.items.length === 0 ? (
                        <p className="text-muted">{section.emptyText}</p>
                    ) : (
                        <List className="flex flex-col">
                            {section.items.map((item, index) => (
                                <li
                                    key={getItemKey(item, index)}
                                    className="flex items-center gap-6 border-b border-border py-3 last:border-b-0"
                                >
                                    {marker === 'dot' ? (
                                        <span aria-hidden="true" className="h-3 w-3 shrink-0 rounded-full bg-primary" />
                                    ) : (
                                        <span
                                            aria-hidden="true"
                                            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-white"
                                        >
                                            {index + 1}
                                        </span>
                                    )}
                                    <div className="min-w-0 flex-1">{renderItem(item, index)}</div>
                                </li>
                            ))}
                        </List>
                    )}
                </ProfileSection>
            ))}
        </>
    );
};

export default NumberedSections;
